export default __webpack_public_path__ + "static/media/head01_th_pc.575da03e.png";